<template>
  <div class="container" v-if="result.hasOwnProperty('ballast')">
    <div class="row">
      <div class="common__title-result">
        Балласт
      </div>
      <div class="ballast">
        <div class="ballast__head">
          <div class="ballast__head-title">Наименование</div>
          <div class="ballast__head-title">Объем</div>
        </div>
        <div class="ballast__item" v-for="(item, i) in ballast" :key="i">
          <div class="ballast__item-img">
            <img :src="findBallastImg(item.type)"
                 :alt="item.type === 'reinforced' ? 'Армированная стяжка' : 'Гранитный щебень'">
          </div>
          <div class="ballast__item-title">
            {{ item.type === 'reinforced' ? 'Армированная стяжка' : 'Гранитный щебень' }}
          </div>
          <div class="ballast__item-volume">{{ item.volume }} м³</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex';

export default {
  props: {
  },
  data() {
    return {
      isShowRemaining: false,
    };
  },
  components: {
  },
  methods: {
    findBallastImg(name) {
      return this.ballastArray.types[this.ballastArray.types.findIndex(
        p => p.value === name,
      )].image;
    },
  },
  computed: {
    ...mapState({
      result: state => state.result.total,
      ballast: state => state.result.total.ballast,
      mounting: state => state.mounting,
    }),
    ballastArray() {
      return this.mounting[this.mounting.findIndex(p => p.value === 'ballast')];
    },
  },
};
</script>
<style lang="sass" scoped>
  .ballast
    width: 100%
    color: $black
    text-align: left
    &__head
      display: grid
      background: #F6F6F6
      border: rem(1) solid #ECECEC
      box-sizing: border-box
      border-radius: rem(4) rem(4) 0 0
      +media((padding: (320: rem(16) rem(24), 992: rem(25) rem(40))))
      +media((grid-template-columns: (320: 4fr 7fr 3fr, 768: 3fr 17fr 2fr)))
      &-title
        font-style: normal
        font-weight: bold
        font-size: rem(14)
        line-height: rem(18)
        color: $black
        &:first-of-type
          grid-column-start: 2
    &__item
      display: grid
      +media((grid-template-columns: (320: 4fr 7fr 3fr, 768: 3fr 17fr 2fr)))
      +media((padding: (320: 0 rem(24), 992: 0 rem(40))))
      background: #fff
      margin-bottom: rem(1)
      min-height: rem(60)
      &-title, &-volume
        font-style: normal
        font-weight: 500
        font-size: rem(14)
        display: flex
        flex-direction: row
        align-items: center
        +media((line-height: (320: rem(20), 992: rem(30))))
      &-img
        display: flex
        flex-direction: column
        justify-content: center
        align-items: flex-start
        img
          max-width: rem(69)
          max-height: rem(40)
          object-fit: cover
</style>
